import React from 'react';
import Routes from './routes/Routes';
import { AuthProvider } from './context/AuthContext';
import { SignalRProvider } from './context/signalRContext';

const App = () => {
  return (
    <div style={{ height: '100vh', width: '100vw' }}>
      <AuthProvider>
        <SignalRProvider>
          <Routes />
        </SignalRProvider>
      </AuthProvider>
    </div>
  );
};

export default App;
